import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Modal, OverlayTrigger } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import CustomSelect from "../../components/uiFormElement/newSelect";
import SystemContext from "../../context/systemContext";
import { api } from "../../services/api/api";
import { BaseResponse } from "../../services/api/response/BaseResponse";
import browserStorage from "../../services/storage";
import { headerHeight, language } from "./navigator.constants";
import Notification from "./notification/container/Notification";
import get from "lodash.get";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import CalendarIcon from "../../assets/images/icons/CalendarIcon";
import LockOpen from "../../assets/images/icons/LockOpen";
import LogoE from "../../assets/images/icons/LogoE";
import LogOut from "../../assets/images/icons/LogOut";
import MoonIcon from "../../assets/images/icons/MoonIcon";
import SunIcon from "../../assets/images/icons/SunIcon";
import UserImageDefault from "../../assets/images/user.svg";
import { ReactSelect } from "../../components/formElements/formSelect/style";
import { popover } from "./aside/components/popover";
import GoBackButton from "./goBackButton/GoBackButton";
import {
  HeaderStyled,
  LanguageBox,
  RoundedButton,
  UserPopoverStyled,
  UserStyled,
} from "./header.style";
import AdditionalMenu from "./additionalMenu/AdditionalMenu";
import {
  CancelButton,
  CustomIconStyle,
  StyledButton,
} from "../../assets/styles/Button";
import SectionsVideo from "./video/container/SectionsVideo";
import CustomInput from "../../components/formElements/input/input";
import { debounce } from "../../services/debounce";
import { useRequest } from "../../hooks/useRequest/UseRequest";
import RoleManager from "../../services/roleManagement";
import useOutsideClick from "../../hooks/useOutsideClick/useOutsideClick";
import NewsBox from "./news/NewsBox";
import StatisticsIcon from "../../assets/images/icons/StatisticsIcon";
import ActiveSessionIcon from "./assets/ActiveSessionIcon";

const Header = () => {
  const history = useHistory();
  const [show, setShow] = useState<boolean>(false);
  const [showGlobalSearch, setShowGlobalSearch] = useState<boolean>(false);
  const {
    branchList: branches,
    setThemeState,
    themeState,
    ...context
  }: any = useContext(SystemContext);

  let localUser = localStorage.getItem("user");
  const [user, setUser] = useState<any>();
  const [value, setValue] = useState({ _id: "", name: "" });
  const [showUserPopover, setShowUserPopover] = useState(false);
  const currLanguage: any = browserStorage.get("i18nextLng");
  const [defaultLanguage, setDefaultLanguage] = useState(currLanguage || "uz");
  const { t, i18n } = useTranslation();
  const theme: any = useTheme();
  const [globalSearchClient, globalSearchData] = useRequest();
  const [hasAccess] = RoleManager();
  const globalSearchRef = useRef(null);
  const [modal, setModal] = useState<boolean>(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false); // Mobil menyu holati

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen); // Mobil menyuni ochish/yopish
  };


  const Logout = () => {
    setModal(true);
    setShowUserPopover(false);
  };

  const handleLogout = async () => {
    lock();
    try {
      const b = await currLanguage;
      localStorage.clear();
      browserStorage.set("i18nextLng", b);
      history.push("/");
    } catch (e) {
      toast.error(t(`TOAST_MESSAGES.Error`));
    }
  };

  const branch: any = browserStorage.get("branch");

  const getBranch = () => {
    const oldBranch = branches?.find((item: any) => item._id === branch);

    if (!oldBranch) {
      setValue(branches[0]);
      browserStorage.set("branch", branches[0]?._id);
      return;
    }

    setValue({
      _id: branch,
      name: branches?.find((item: any) => item._id === branch)?.name,
    });
  };

  useEffect(() => {
    if (globalSearchData) {
      setShowGlobalSearch(true);
    }
  }, [globalSearchData]);

  useEffect(() => {
    getBranch();
  }, [branches]);

  const lock = async () => {
    try {
      const res = await api.apiCall<BaseResponse<any>>("log-out", {}, "get");
      if (res.data) toast.success(t(`TOAST_MESSAGES.Success`));
    } catch (err: any) {
      throw new Error(err);
    }
  };

  useMemo(() => {
    if (localUser) {
      setUser(JSON.parse(localUser));
    } else setUser(context.profile);
  }, [localUser, context.profile]);

  const onClickLock = () => {
    let phoneNumber: undefined | string = get(
      context,
      "profile.phoneNumber",
      browserStorage.get("phoneNumber")
    );
    let currentPath = history.location.pathname;
    let i18nextLng = browserStorage.get("i18nextLng");
    localStorage.clear();
    browserStorage.set("phoneNumber", phoneNumber);
    browserStorage.set("currentPath", currentPath);
    browserStorage.set("i18nextLng", i18nextLng);
    history.push("/");
  };

  const sunMoonIconClick = useCallback(
    (state: string) => {
      browserStorage.set("themeState", state);
      setThemeState(state);
    },
    [themeState]
  );

  const renderUserPopover = () => (
    <UserPopoverStyled>
      <div
        className="user-info"
        onClick={() => {
          history.push(`/hr/employees/profile/${get(user, "_id")}`);
        }}
      >
        <div className="image-div">
          <img
            src={
              user?.image
                ? process.env.REACT_APP_PRODUCTION_URL + user.image
                : UserImageDefault
            }
            alt="Logged User"
          />
        </div>
        <div className="name">
          <span className="user_name">
            {user?.firstName + " " + user?.lastName}
          </span>
          <span className="phone-number">{user?.phoneNumber}</span>
        </div>
      </div>
      <div onClick={() => history.push("/active-session")} className="main_tab">
        <RoundedButton className={"btn btn-light"}>
          <ActiveSessionIcon />
        </RoundedButton>
        <span>{t("GENERAL.active_sessions")}</span>
      </div>
      <div onClick={onClickLock} className="main_tab">
        <RoundedButton className={"btn btn-light"}>
          <LockOpen />
        </RoundedButton>
        <span>{t("GENERAL.lock")}</span>
      </div>
      <div className="logout main_tab" onClick={Logout}>
        <RoundedButton className={"btn ml-auto"}>
          <LogOut />
        </RoundedButton>
        <span>{t("GENERAL.logout")}</span>
      </div>
    </UserPopoverStyled>
  );

  useOutsideClick(globalSearchRef, () => {
    setShowGlobalSearch(false);
  });

  const globalSearch = (event: any) => {
    globalSearchClient.post("global", {
      page: 1,
      limit: 10,
      sortBy: "_id",
      sortOrder: -1,
      search: event.target.value,
    });
  };

  const handleGlobalInputChange = debounce(globalSearch, 600);

  const changeLanguage = (language: string) => {
    setDefaultLanguage(language);
    i18n.changeLanguage(language);
  };

  const toggleTheme = () => {
    const newTheme = themeState === "light" ? "dark" : "light";
    sunMoonIconClick(newTheme); // Argument bilan chaqiriladi
  };

  return (
    <HeaderStyled>
      <Modal onHide={() => setShow(false)} show={show} centered={true}>
        <div className="p-4"></div>
      </Modal>
      <Modal show={modal} onHide={() => setModal(false)} centered={true}>
        <Modal.Body>
          <h4 className="text-center mb-4">{t("GENERAL.REALLY_LEAVE")}</h4>
          <div className="d-flex align-items-center justify-content-end mt-3">
            <CancelButton type="button" onClick={() => setModal(false)}>
              {t("GENERAL.NO")}
            </CancelButton>
            <StyledButton type="button" onClick={handleLogout}>
              {t("GENERAL.YES")}
            </StyledButton>
          </div>
        </Modal.Body>
      </Modal>
      <div
        style={{
          height: headerHeight,
          background: `${theme.white.main}`,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
        }}
        className={"d-block justify-content-between d-flex"}
      >
        <div className="header-left-side">
          <div className="logo-main">
            <Link to="/home">
              <LogoE />
            </Link>
          </div>
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              <GoBackButton />
            </div>

            <div className="hidden md:flex">
              <ReactSelect
                value={{
                  value: get(value, "_id", ""),
                  label: get(value, "name", ""),
                }}
                isClearable={false}
                onChange={(e: any) => {
                  setValue(e);
                  browserStorage.set("branch", e.value);
                  window.location.reload();
                }}
                className="mx-4"
                classNamePrefix="react-select"
                options={branches?.map((item: any) => ({
                  label: item.name,
                  value: item._id,
                }))}
              />
              <div className="global-search">
                <div className="search-input">
                  <CustomInput
                    params={{
                      placeholder: t("GENERAL.SEARCH") + " ...",
                      onChange: handleGlobalInputChange,
                    }}
                  />
                </div>
                {showGlobalSearch && (
                  <div className="list" ref={globalSearchRef}>
                    <h5 className="item-title">{t("HR.STUDENTS")}</h5>
                    {globalSearchData?.data?.students?.map((item: any) => (
                      <div
                        className="item"
                        onClick={() => {
                          if (hasAccess("updateStudent"))
                            history.push(
                              `/students/student-list/edit/${item._id}`
                            );
                          setShowGlobalSearch(false);
                        }}
                      >
                        <span className="name">
                          {get(item, "firstName", "") +
                            " " +
                            get(item, "lastName", "")}
                        </span>
                        <span className="phone">
                          {get(item, "phoneNumber", "")}
                        </span>
                      </div>
                    ))}
                    <h5 className="item-title">{t("GENERAL.GROUPS")}</h5>
                    {globalSearchData?.data?.groups?.map((item: any) => (
                      <div
                        className="item"
                        onClick={() => {
                          if (hasAccess("getGroup"))
                            history.push(
                              `/group/groups/details/${get(item, "_id", "")}`
                            );
                          setShowGlobalSearch(false);
                        }}
                      >
                        <span className="name">{item.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Hamburger Icon for Mobile */}
        <button
          onClick={toggleMobileMenu}
          className="lg:hidden p-2 focus:outline-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div style={{ zIndex: 1000 }} className="lg:hidden absolute top-16 right-2 bg-white shadow-lg w-64 p-4">
            <div className="md:hidden">
              <ReactSelect
                value={{
                  value: get(value, "_id", ""),
                  label: get(value, "name", ""),
                }}
                isClearable={false}
                onChange={(e: any) => {
                  setValue(e);
                  browserStorage.set("branch", e.value);
                  window.location.reload();
                }}
                className="mx-4"
                classNamePrefix="react-select"
                options={branches?.map((item: any) => ({
                  label: item.name,
                  value: item._id,
                }))}
              />
              <div className="global-search mt-2">
                <div className="search-input">
                  <CustomInput
                    params={{
                      placeholder: t("GENERAL.SEARCH") + " ...",
                      onChange: handleGlobalInputChange,
                    }}
                  />
                </div>
                {showGlobalSearch && (
                  <div className="list" ref={globalSearchRef}>
                    <h5 className="item-title">{t("HR.STUDENTS")}</h5>
                    {globalSearchData?.data?.students?.map((item: any) => (
                      <div
                        className="item"
                        onClick={() => {
                          if (hasAccess("updateStudent"))
                            history.push(
                              `/students/student-list/edit/${item._id}`
                            );
                          setShowGlobalSearch(false);
                        }}
                      >
                        <span className="name">
                          {get(item, "firstName", "") +
                            " " +
                            get(item, "lastName", "")}
                        </span>
                        <span className="phone">
                          {get(item, "phoneNumber", "")}
                        </span>
                      </div>
                    ))}
                    <h5 className="item-title">{t("GENERAL.GROUPS")}</h5>
                    {globalSearchData?.data?.groups?.map((item: any) => (
                      <div
                        className="item"
                        onClick={() => {
                          if (hasAccess("getGroup"))
                            history.push(
                              `/group/groups/details/${get(item, "_id", "")}`
                            );
                          setShowGlobalSearch(false);
                        }}
                      >
                        <span className="name">{item.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <LanguageBox>
              <button
                onClick={() => changeLanguage("uz")}
                className={defaultLanguage === "uz" ? "active" : ""}
              >
                O'zb
              </button>
              <button
                onClick={() => changeLanguage("ru")}
                className={defaultLanguage === "ru" ? "active" : ""}
              >
                Рус
              </button>
              <button
                onClick={() => changeLanguage("en")}
                className={defaultLanguage === "en" ? "active" : ""}
              >
                Eng
              </button>
            </LanguageBox>
            <div className="mt-4 flex justify-between items-center">
              <NewsBox />
              <SectionsVideo />
              <AdditionalMenu />
              <Notification />
            </div>
          </div>
        )}

        {/* Desktop Menu */}
        <div className="header-right-side hidden lg:flex align-items-center">

          <LanguageBox>
            <button
              onClick={() => changeLanguage("uz")}
              className={defaultLanguage === "uz" ? "active" : ""}
            >
              O'zb
            </button>
            <button
              onClick={() => changeLanguage("ru")}
              className={defaultLanguage === "ru" ? "active" : ""}
            >
              Рус
            </button>
            <button
              onClick={() => changeLanguage("en")}
              className={defaultLanguage === "en" ? "active" : ""}
            >
              Eng
            </button>
          </LanguageBox>
          <div className="d-flex gap-2 align-items-center">
            <div onClick={toggleTheme} className="cursor-pointer mb-2 ml-4 text-[20px]">
              {themeState === "light" ? <MoonIcon /> : <SunIcon />}
            </div>
            <NewsBox />
            <SectionsVideo />
            <AdditionalMenu />
            <Notification />
          </div>

          <div
            onMouseEnter={() => setShowUserPopover(true)}
            onMouseLeave={() => setShowUserPopover(false)}
            className="d-flex align-items-center text-decoration-none m-0 p-0"
            style={{ height: "100%" }}
          >
            <OverlayTrigger
              placement="bottom-end"
              overlay={popover("", renderUserPopover())}
              show={showUserPopover}
            >
              <UserStyled
                className={
                  "btn ml-auto mx-3 d-flex align-items-center justify-content-center"
                }
              >
                {user?.image ? (
                  <img
                    src={process.env.REACT_APP_PRODUCTION_URL + user?.image}
                    alt="Logged User"
                  />
                ) : (
                  <span>{user?.firstName?.[0]}</span>
                )}
              </UserStyled>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </HeaderStyled>
  );
};

export default memo(Header);